/**
 * The default alphabet is 25 numbers and lowercase letters.
 * Any numbers that look like letters and vice versa are removed:
 * 1 l, 0 o.
 * Also the following letters are not present, to prevent any
 * expletives: cfhistu
 */
var alphabet = '23456789abdegjkmnpqrvwxyz';
var alphabet_length = alphabet.length;
var id_length = 8;

export function createID() {
	var created_id = '';
	for (var i = 0; i < id_length; i++) {
		created_id += alphabet.charAt(Math.floor(Math.random() * alphabet_length));
	}
	// used_list_ids.push(created_id);
	return created_id;
}

var used_list_ids = [];

function isIdUnique(id) {
	var unique = true;
	used_list_ids.forEach(function (oldID) {
		if (id == oldID) {
			unique = false;
			return false;
		}
	});
	return unique;
}

export function createUniqueID() {
	var created_id = createID();
	var is_unique = isIdUnique(created_id);
	while (is_unique == false) {
		created_id = createID();
		is_unique = isIdUnique(created_id);
	}
	used_list_ids.push(created_id);
	return created_id;
}
